import { render } from "./StudentPracticumAttendanceDataTable.vue?vue&type=template&id=5ff42c7f&scoped=true"
import script from "./StudentPracticumAttendanceDataTable.vue?vue&type=script&lang=js"
export * from "./StudentPracticumAttendanceDataTable.vue?vue&type=script&lang=js"

import "./StudentPracticumAttendanceDataTable.vue?vue&type=style&index=0&id=5ff42c7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff42c7f"]])

export default __exports__